<template>
  <tbody>
    <template v-for="row in allRows">
      <tr
        v-if="row.isLoadMore"
        :key="`loadmore-${row.parentId}`"
        class="load-more-row"
      >
        <td :colspan="dayColumns.length + 2">
          <a-button
            size="small"
            type="default"
            @click="emitLoadMore(row.parentId)"
          >
            {{ $t("commons.load_more") || "Load more" }}
          </a-button>
        </td>
      </tr>

      <LogworkRow
        v-if="!row.isChild"
        :key="`row-${row.id}`"
        :row="row"
        :dayColumns="dayColumns"
        :itemType="itemType"
        :showExpand="expandableRows && itemType !== 'summary'"
        :expanded="expandedRows.includes(row.id)"
        :loading="loadingRows.includes(row.id)"
        :viewMode="viewMode"
        :isShowHour="isShowHour"
        :expandTrigger="expandTrigger"
        @toggle-expand="onToggleExpand"
      />

      <LogworkChildRow
        v-else
        :key="`child-${row.id}`"
        :row="row"
        :dayColumns="dayColumns"
        :viewMode="viewMode"
        @view-detail="$emit('view-detail', $event)"
        @create-logwork="$emit('create-logwork', $event)"
      />
    </template>
  </tbody>
</template>

<script>
import LogworkRow from "./LogworkRow.vue";
import LogworkChildRow from "./LogworkChildRow.vue";

export default {
  name: "LogworkTableBody",
  components: {
    LogworkRow,
    LogworkChildRow
  },
  props: {
    allRows: { type: Array, required: true },
    dayColumns: { type: Array, required: true },
    itemType: { type: String, default: "summary" },
    expandableRows: { type: Boolean, default: false },
    expandedRows: { type: Array, default: () => [] },
    loadingRows: { type: Array, default: () => [] },
    viewMode: { type: String, default: 'day' },
    isShowHour: { type: Boolean, default: true },
    expandTrigger: Number
  },
  methods: {
    onToggleExpand(row) {
      this.$emit("toggle-expand", row);
    },
    emitLoadMore(parentId) {
      this.$emit("load-more-child", parentId);
    }
  }
};
</script>
